/* SteelFit routine quiz (templates/page.quiz.json → sections/sf-quiz.liquid).
   Builds the routine from the answers with the rules set in the section, shows flavor pickers, lets shoppers
   remove/add products, and adds everything with the line property _sf_src = quiz (sf-theme.js applies the
   2 / 3 / 4+ item codes from Theme settings). State survives a reload in sessionStorage. Vanilla ES2018. */
(() => {
  'use strict';
  const ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';
  const ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5 10 17l9-10"/></svg>';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const lines = s => String(s || '').split(/\r?\n/).map(x => x.trim()).filter(Boolean);
  const KEY = 'sf-quiz';

  /* "goal=strength train=hybrid,mixed glp!=yes" → [{k, neg, vals}] (all must match; unanswered never equals) */
  const parseCond = s => String(s || '').trim().split(/\s+/).filter(Boolean).map(tok => {
    const m = tok.match(/^([\w-]+)(!?=)(.*)$/);
    return m ? { k: m[1], neg: m[2] === '!=', vals: m[3].split(',').map(v => v.trim()).filter(Boolean) } : null;
  }).filter(Boolean);
  const test = (conds, a) => conds.every(c => { const hit = a[c.k] != null && c.vals.includes(String(a[c.k])); return c.neg ? !hit : hit; });

  function init() {
    const root = document.querySelector('[data-quiz]');
    const dataEl = document.querySelector('[data-quiz-json]');
    if (!root || !dataEl || root.dataset.ready) return;
    let D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.ready = '1';
    const Lel = document.querySelector('[data-qz-l]');
    const L = k => (Lel && Lel.dataset[k]) || '';
    const money = c => (window.SF && SF.formatMoney ? SF.formatMoney(c) : '$' + (c / 100).toFixed(2));
    const say = m => { if (window.SF && SF.say) SF.say(m); };
    const introHTML = root.innerHTML;
    // The email form is rendered once by Liquid (Shopify customer form); each results view gets a copy.
    const tplWrap = document.querySelector('[data-qz-email-tpl]');
    const emailForm = tplWrap && tplWrap.firstElementChild;
    if (tplWrap) tplWrap.remove();

    /* ---------- data ---------- */
    const Q = (D.questions || []).filter(q => q.used && q.key).map(q => Object.assign({}, q, {
      opts: lines(q.answers).map(l => { const [v, label, small, summ] = l.split('|').map(x => (x || '').trim()); return { v, label: label || v, small: small || '', summ: summ || '' }; }).filter(o => o.v)
    })).filter(q => q.opts.length);
    const P = (D.products || []).map(p => Object.assign({}, p, {
      useC: parseCond(p.use), outC: lines(p.out).map(parseCond).filter(c => c.length),
      handle: (String(p.url || '').match(/\/products\/([^/?#]+)/) || [])[1] || ''
    }));
    const RULES = lines(D.rules).map(l => { const [c, k] = l.split('->'); return k ? { c: parseCond(c), keys: k.split(',').map(x => x.trim()).filter(Boolean) } : null; }).filter(Boolean);
    const HEADS = {}; lines(D.headlines).forEach(l => { const i = l.indexOf('|'); if (i > 0) HEADS[l.slice(0, i).trim()] = l.slice(i + 1).trim(); });
    const sig = Q.map(q => q.key).join() + '|' + P.map(p => p.key + p.handle).join();

    const resolve = (key, a) => P.findIndex(p => p.key === key && p.ok && (!p.useC.length || test(p.useC, a)));
    const leftOut = (p, a) => p.outC.some(c => test(c, a));
    const stack = a => {
      const s = [];
      RULES.forEach(r => { if (!test(r.c, a)) return; r.keys.forEach(k => { const i = resolve(k, a); if (i >= 0 && !s.includes(i)) s.push(i); }); });
      return s.filter(i => !leftOut(P[i], a)).slice(0, 4);
    };
    const tierPct = n => { const t = D.pct || [10, 15, 20]; return n >= 4 ? t[2] : n === 3 ? t[1] : n === 2 ? t[0] : 0; };

    /* ---------- state ---------- */
    const fresh = () => ({ sig, step: -1, a: {}, v: {}, rm: [], extra: [], msg: '' });
    let st = fresh();
    try { const sv = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (sv && sv.sig === sig) st = Object.assign(fresh(), sv); } catch (e) {}
    st.rm = (st.rm || []).filter(i => P[i]); st.extra = (st.extra || []).filter(i => P[i] && P[i].ok);
    if (st.step > Q.length) st.step = Q.length;
    const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };

    const answered = () => { const o = {}; Q.slice(0, Math.max(0, st.step)).forEach(q => { if (q.key in st.a) o[q.key] = st.a[q.key]; }); return o; };
    const final = () => { const base = stack(st.a).filter(i => !st.rm.includes(i)); st.extra.forEach(i => { if (!base.includes(i)) base.push(i); }); return base; };
    const selIdx = i => { const p = P[i], k = st.v[i]; if (p.vars[k] && p.vars[k].ok) return k; const f = p.vars.findIndex(v => v.ok); return f < 0 ? 0 : f; };
    const selVar = i => P[i].vars[selIdx(i)];
    const nProducts = n => (n === 1 ? L('nOne') : L('nOther').replace('%n', n));
    const joinAnd = arr => (arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' ' + L('and') + ' ' + arr[arr.length - 1]);
    const sameFam = (x, y) => P[x].key === P[y].key || (!!P[x].fam && P[x].fam === P[y].fam);
    const diff = (prev, next, q) => {
      const nm = i => P[i].title, add = next.filter(i => !prev.includes(i)), gone = prev.filter(i => !next.includes(i));
      if (add.length === 1 && gone.length === 1 && sameFam(add[0], gone[0])) return L('switched').replace('%s', nm(add[0]));
      const parts = [];
      if (add.length) parts.push(L('added').replace('%s', joinAnd(add.map(nm))));
      if (gone.length) parts.push(L('removed').replace('%s', joinAnd(gone.map(nm))) + (q.removed || ''));
      return parts.join('. ');
    };
    const totals = ids => {
      const pct = tierPct(ids.length), sub = ids.reduce((t, i) => t + selVar(i).price, 0), disc = ids.reduce((t, i) => t + Math.round(selVar(i).price * pct / 100), 0);
      return { pct, sub, disc, total: sub - disc };
    };
    const img = (src, w) => (src ? `<img src="${esc(src)}" alt="" width="${w}" height="${w}">` : '');
    const pImg = (i, w) => { const v = selVar(i); return img((v && v.img) || P[i].img, w); };

    /* ---------- views ---------- */
    const tray = () => {
      const ids = stack(answered()), pct = tierPct(ids.length);
      return `<aside class="qz-tray" aria-label="${esc(L('tray'))}"><div class="qt-h"><b>${esc(D.sumTitle)}</b><span class="num">${esc(nProducts(ids.length))}${pct ? ' · ' + esc(L('save').replace('%p', pct)) : ''}</span></div>
        ${ids.length ? `<ul class="qt-list" role="list">${ids.map(i => `<li><span class="li-art" aria-hidden="true">${pImg(i, 44)}</span><span class="qt-nm">${esc(P[i].title)}</span></li>`).join('')}</ul>` : `<p class="qt-empty">${esc(L('trayEmpty'))}</p>`}
        ${st.msg ? `<p class="qt-msg">${ICON_CHECK}<span>${esc(st.msg)}</span></p>` : ''}</aside>`;
    };
    const swatches = i => {
      const p = P[i]; if (!p.kind || !p.vars.length) return '';
      const vi = selIdx(i), lab = p.kind === 'scent' ? L('scent') : L('flavor'), n = p.vars.length;
      const labN = n > 1 ? `${(p.kind === 'scent' ? L('scents') : L('flavors')) || lab} (${n})` : lab;
      return `<div class="qz-var"><p class="lp-opt-l"><span>${esc(labN)}</span> <b>${esc(p.vars[vi].v)}</b></p><div class="lp-swatches" role="group" aria-label="${esc(p.title + ' ' + lab.toLowerCase())}">${p.vars.map((v, k) =>
        `<button type="button" class="lp-sw${v.sw ? '' : ' no-sw'}" data-qzv="${i}:${k}" aria-pressed="${k === vi}"${v.ok ? '' : ' disabled'}>${v.sw || ''}${esc(v.v)}${v.ok ? '' : ` <span class="sr">(${esc(L('soldOut'))})</span>`}</button>`).join('')}</div></div>`;
    };
    const itemUrl = i => { const v = selVar(i); return P[i].url + (v && P[i].kind ? '?variant=' + v.id : ''); };

    const renderStep = () => {
      const q = Q[st.step], n = Q.length;
      root.innerHTML = `<div class="qz-progress"><span class="num">${esc(L('qOf').replace('%n', st.step + 1).replace('%t', n))}</span><div class="bar" aria-hidden="true"><i style="width:${st.step / n * 100}%"></i></div></div>
        <div class="qz-run"><div class="qz-q"><h1 tabindex="-1">${esc(q.q)}</h1>${q.sub ? `<p class="lead">${esc(q.sub)}</p>` : ''}
        <div class="qz-opts" role="group" aria-label="${esc(q.q)}">${q.opts.map(o => `<button type="button" class="qz-opt" data-qa="${esc(o.v)}" aria-pressed="${st.a[q.key] === o.v}"><span><b>${esc(o.label)}</b>${o.small ? `<small>${esc(o.small)}</small>` : ''}</span><span class="go" aria-hidden="true">${ICON_ARROW}</span></button>`).join('')}</div>
        <div class="qz-nav"><button type="button" class="qz-back" data-qz-back>${esc(st.step === 0 ? L('backStart') : L('back'))}</button></div></div>${tray()}</div>`;
    };

    const renderResults = () => {
      const a = st.a, ids = final(), T = totals(ids);
      const head = HEADS[a[D.headlineQ]] || D.headline || '';
      const tags = Q.filter(q => q.summary && a[q.key] != null).map(q => { const o = q.opts.find(x => x.v === a[q.key]); return o ? (o.summ || o.label) : ''; }).filter(Boolean);
      let lead = String(D.resLead || '');
      lead = tags.length ? lead.replace('[answers]', tags.join(' · ')) : lead.replace(/^[^.]*\[answers\][^.]*\.\s*/, '');
      const showNote = D.note && D.noteWhen && test(parseCond(D.noteWhen), a);
      const sugs = [...st.rm, ...P.map((p, i) => (p.sug ? i : -1)).filter(i => i >= 0)]
        .filter((i, k, arr) => arr.indexOf(i) === k && P[i] && P[i].ok && !ids.includes(i) && !leftOut(P[i], a)).slice(0, 3);
      const addAll = ids.length ? L('addAll').replace('%n', ids.length) : L('addAll').replace(/\s*%n/, '');
      root.innerHTML = `<div class="qz-progress"><span>${esc(L('done'))}</span><div class="bar" aria-hidden="true"><i style="width:100%"></i></div></div>
        ${D.resEyebrow ? `<p class="eyebrow" style="margin-top:26px">${esc(D.resEyebrow)}</p>` : ''}<h1 style="margin-top:10px" tabindex="-1">${esc(head)}</h1>${lead ? `<p class="lead">${esc(lead)}</p>` : ''}
        ${showNote ? `<div class="note-box">${D.note}</div>` : ''}
        <div class="qz-res"><div><h2 class="sr">${esc(L('productsH'))}</h2>
          ${ids.length ? ids.map(i => { const p = P[i], v = selVar(i); return `<div class="qz-item" id="qzi-${i}"><a class="li-art" href="${esc(itemUrl(i))}" tabindex="-1" aria-hidden="true">${pImg(i, 96)}</a><div>${p.when ? `<span class="when">${esc(p.when)}</span>` : ''}<h3><a href="${esc(itemUrl(i))}">${esc(p.title)}</a></h3>${p.why ? `<p>${esc(p.why)}</p>` : ''}${swatches(i)}<button class="linkish qz-rm" type="button" data-qzrm="${i}" aria-label="${esc(L('removeL').replace('%s', p.title))}">${esc(L('remove'))}</button></div><span class="price num">${money(v.price)}</span></div>`; }).join('') : `<p class="qz-emptyres">${esc(L('empty'))}</p>`}
          ${sugs.length ? `<div class="qz-sug"><p class="eyebrow">${esc(D.sugTitle)}</p><div class="qz-sug-list">${sugs.map(i => `<button type="button" class="qz-sugb" data-qzadd="${i}"><span class="li-art" aria-hidden="true">${pImg(i, 44)}</span><span class="qs-t"><b>${esc(P[i].title)}</b><small class="num">${money(selVar(i).price)}</small></span><span class="qs-plus" aria-hidden="true">+</span><span class="sr">${esc(L('addTo'))}</span></button>`).join('')}</div></div>` : ''}
        </div>
        <aside class="mini-sum" aria-label="${esc(D.sumTitle)}"><h3>${esc(D.sumTitle)}</h3>
          <div class="r"><span>${esc(nProducts(ids.length))}</span><b class="num">${money(T.sub)}</b></div>
          ${T.pct ? `<div class="r save"><span>${esc(L('savings').replace('%p', T.pct))}</span><b class="num">−${money(T.disc)}</b></div>` : `<p class="fine" style="margin:0">${esc(L('saveHint'))}</p>`}
          <div class="r total"><span>${esc(L('total'))}</span><b class="num">${money(T.total)}</b></div>
          <button class="btn btn-primary btn-block" type="button" data-qz-add${ids.length ? '' : ' disabled'}>${esc(addAll)}</button>
          <button class="qz-back" type="button" data-qz-retake style="justify-self:center">${esc(L('retake'))}</button>
          <div class="qz-email-slot" data-qz-email-slot></div>
        </aside></div>`;
      const slot = root.querySelector('[data-qz-email-slot]');
      if (slot && emailForm) slot.appendChild(emailForm.cloneNode(true)); else if (slot) slot.remove();
    };

    const render = () => {
      if (st.step < 0) root.innerHTML = introHTML;
      else if (st.step < Q.length) renderStep();
      else renderResults();
      save();
    };
    const toTop = () => {
      const h = root.querySelector('h1');
      const y = root.getBoundingClientRect().top + window.pageYOffset - 120;
      if (window.pageYOffset > y) window.scrollTo(0, Math.max(0, y));
      if (h) h.focus({ preventScroll: true });
    };
    const refocus = sel => { const n = sel && root.querySelector(sel); if (n) n.focus({ preventScroll: true }); };

    /* ---------- events ---------- */
    root.addEventListener('click', e => {
      const t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      let top = true, focus = null;
      if (t.hasAttribute('data-qz-start')) { st.step = 0; st.msg = ''; }
      else if (t.dataset.qa != null && st.step >= 0 && st.step < Q.length) {
        const q = Q[st.step], prev = stack(answered());
        st.a[q.key] = t.dataset.qa; st.step++;
        const next = stack(answered());
        st.msg = diff(prev, next, q) || (next.length ? L('noted') : '');
        if (st.step >= Q.length) { st.rm = []; st.extra = []; }
      }
      else if (t.hasAttribute('data-qz-back')) { st.step = Math.max(-1, st.step - 1); st.msg = ''; }
      else if (t.hasAttribute('data-qz-retake')) { st = fresh(); st.step = 0; }
      else if (t.dataset.qzv) { const [i, k] = t.dataset.qzv.split(':').map(Number); st.v[i] = k; top = false; focus = `[data-qzv="${i}:${k}"]`; }
      else if (t.dataset.qzrm) {
        const i = Number(t.dataset.qzrm), list = final(), at = list.indexOf(i);
        if (!st.rm.includes(i)) st.rm.push(i); st.extra = st.extra.filter(x => x !== i); top = false;
        const nx = list[at + 1] != null ? list[at + 1] : list[at - 1];
        focus = nx != null ? `[data-qzrm="${nx}"]` : '[data-qzadd]';
        say(L('removedSay').replace('%s', P[i].title));
      }
      else if (t.dataset.qzadd) {
        const i = Number(t.dataset.qzadd);
        if (!st.extra.includes(i)) st.extra.push(i); st.rm = st.rm.filter(x => x !== i); top = false; focus = `[data-qzrm="${i}"]`;
        say(L('addedSay').replace('%s', P[i].title));
      }
      else if (t.hasAttribute('data-qz-add')) {
        const ids = final(); if (!ids.length || !window.SF || !SF.cart) return;
        const items = ids.map(i => ({ id: selVar(i).id, quantity: 1, properties: { _sf_src: 'quiz' } }));
        t.disabled = true;
        SF.cart.add(items, { returnTo: t }).catch(() => {}).then(() => { t.disabled = false; });
        return;
      }
      else return;
      render();
      if (top) toTop(); else if (!focus || !root.querySelector(focus)) refocus('[data-qz-add]'); else refocus(focus);
    });
    root.addEventListener('submit', e => {
      const f = e.target.closest('[data-qz-email]'); if (!f) return;
      const tags = f.querySelector('[data-qz-tags]');
      if (tags) tags.value = ['newsletter', 'quiz'].concat(final().map(i => 'quiz-' + P[i].handle).filter(x => x !== 'quiz-')).join(',');
      save();
    });

    render();
    if (st.step >= 0) {
      const focusOk = () => {
        const ok = root.querySelector('[data-qz-email-ok]');
        if (ok && /customer_posted=true/.test(location.search)) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
      };
      if (document.readyState === 'complete') setTimeout(focusOk, 30); else window.addEventListener('load', () => setTimeout(focusOk, 30), { once: true });
    }
  }

  init();
  document.addEventListener('shopify:section:load', e => { if (e.target && e.target.querySelector('[data-quiz]')) init(); });
})();
